import { FunctionComponent } from "react"

export const $404: FunctionComponent = ()=> {
    return <div className="flex h-[90vh] flex-col justify-center items-center">
       <h1 style={{fontSize:'50px'}} className="text-bold">Oops! It's 404</h1>
    </div>
  
}